export default class InstalationModel {
    idNInstalacion: number | null;
    fkNEmpresa: number | null;
    fkNMunicipio: number | null;
    fldTCodigo: string | null;
    fldTNombre: string | null;
    fldTDireccion: string | null;
    fldTCP: string | null;
    fldTTelefono: string | null;
    fldDAlta: Date | null;
    fldDBaja: Date | null;
    fkNIcono: string | null;
    fkNGestor: number | null;
    fkNTecnico: number | null;
    fkNJefeZona: number | null;
    fkNEjecutivo: number | null;
    fldDApertura: Date | null;
    fldDCierre: Date | null;
    fldNLongitud: number | null;
    fldNLatitud: number | null;
    fldDUltimaTransmisionRecibida: Date | null;
    elementos: number | null;

    // Para manejar la relacion 1 a 1 Con RelacionEmpresaInstalacion
    fkNTipoRelacionEmpresaInstalacion: number | null;

    // Para usar especificamente en el Filtro
    provincia: number | null;

    // Para el mapa
    fldNEstado: number | null;
    
    constructor() {
        this.idNInstalacion = null;
        this.fkNEmpresa = null;
        this.fkNMunicipio = null;
        this.fldTCodigo = null;
        this.fldTNombre = null;
        this.fldTDireccion = null;
        this.fldTCP = null;
        this.fldTTelefono = null;
        this.fldDAlta = null;
        this.fldDBaja = null;
        this.fkNIcono = null;
        this.fkNGestor = null;
        this.fkNTecnico = null;
        this.fkNJefeZona = null;
        this.fkNEjecutivo = null;
        this.fldDApertura = null;
        this.fldDCierre = null;
        this.fldNLongitud = null;
        this.fldNLatitud = null;
        this.provincia = null;
        this.fldNEstado = null;
        this.fkNTipoRelacionEmpresaInstalacion = null;
        this.fldDUltimaTransmisionRecibida = null;
        this.elementos = null;
    }
}